
const TOKEN = 'token'
/* 设置token */
export function set_token(data) {
    return localStorage.setItem(TOKEN, data)
}

/* 获取token */
export function get_token() {
    return localStorage.getItem(TOKEN)
}

/* 删除token' */
export function delete_token() {
    return localStorage.removeItem(TOKEN)
}